export default __webpack_public_path__ + "static/media/Dr.Yann_Lacayo.3a09934b.png";